"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FirebaseAPI = require("./FirebaseAPI");
var DataFilter = require("../filters/DataFilter");
module.exports = /*#__PURE__*/function (_FirebaseAPI) {
  (0, _inherits2["default"])(RealtimeDB, _FirebaseAPI);
  var _super = _createSuper(RealtimeDB);
  function RealtimeDB(firebase, fbPathsConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this;
    (0, _classCallCheck2["default"])(this, RealtimeDB);
    _this = _super.call(this, firebase, fbPathsConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions);
    _this.database = firebase.database().ref();
    return _this;
  }
  (0, _createClass2["default"])(RealtimeDB, [{
    key: "getRef",
    value: function getRef(path) {
      return this.getDb().child(path);
    }
  }, {
    key: "getDb",
    value: function getDb() {
      return this.database;
    }
  }, {
    key: "generateId",
    value: function generateId() {
      return this.getDb().push().key;
    }
  }, {
    key: "fetch",
    value: function fetch(ref, clazz) {
      var _this2 = this;
      return ref.once('value').then(function (snapshot) {
        return _this2.resToData(snapshot, clazz, _this2.refPath(ref));
      });
    }
  }, {
    key: "fetchList",
    value: function fetchList(ref, clazz, options) {
      var _this3 = this;
      return ref.once('value').then(function (snapshot) {
        return _this3.resToDataArray(snapshot, clazz, _this3.refPath(ref));
      });
    }
  }, {
    key: "create",
    value: function create(ref, object, clazz, options) {
      this.ensureIdSet(object);
      var objJson = this.classToPlainHook(object) || object;
      this.log("RealtimeDB create: data = ", object, "path = ", this.refPath(ref));
      return ref.set(objJson).then(function (_) {
        return object;
      });
    }
  }, {
    key: "createDefaultDataFilter",
    value: function createDefaultDataFilter(limit) {
      return new DataFilter(limit);
    }
  }, {
    key: "update",
    value: function update(ref, object, clazz) {
      this.ensureIdSet(object);
      var objJson = this.classToPlainHook(object) || object;
      this.log("RealtimeDB update: data = ", object, "path = ", this.refPath(ref));
      return ref.update(objJson).then(function (_) {
        return object;
      });
    }
  }, {
    key: "set",
    value: function set(ref, object, clazz) {
      this.ensureIdSet(object);
      var objJson = this.classToPlainHook(object) || object;
      this.log("RealtimeDB set: data = ", object, "path = ", this.refPath(ref));
      return ref.set(objJson).then(function (_) {
        return object;
      });
    }
  }, {
    key: "delete",
    value: function _delete(ref, object, clazz) {
      this.log("RealtimeDB delete: data = ", object, "path = ", this.refPath(ref));
      return ref.remove();
    }
  }, {
    key: "refPath",
    value: function refPath(ref) {
      var path = ref.toString();
      return path;
    }
  }, {
    key: "resToData",
    value: function resToData(snapshot, clazz, path) {
      var value = snapshot.val();
      var data = clazz ? this.plainToClassHook(value, clazz) : value;
      this.log("RealtimeDB fetch: data = ", data, "path = ", path);
      return data;
    }
  }, {
    key: "resToDataArray",
    value: function resToDataArray(snapshot, clazz, path) {
      var _this4 = this;
      var result = [];
      snapshot.forEach(function (child) {
        var value = child.val();
        var object = clazz ? _this4.plainToClassHook(value, clazz) : value;
        result.push(object);
      });
      this.log("RealtimeDB fetch: data = ", result, "path = ", path);
      return result;
    }
  }]);
  return RealtimeDB;
}(FirebaseAPI);